import { ProvidersApi, UsersApi } from "users-experience-client";
import { createCommonConfigurationForApis } from "./UsersCommon";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function createUsersApi(): UsersApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';

  if(isGatewayEnabled){
    const basePath = process.env.REACT_APP_USER_API_URL_GATEWAY|| '';
  const axiosInstance: AxiosInstance = spire360ApiClient;
  return new UsersApi(
    undefined,
    `${process.env.REACT_APP_USER_API_URL_GATEWAY}`,
    axiosInstance
  );

  }
  else{
  return new UsersApi(
    createCommonConfigurationForApis(),
    `${process.env.REACT_APP_USER_API_URL}`
  );
  }
  
}


export function createProvidersApi(): ProvidersApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_USER_API_URL_GATEWAY || '';
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new ProvidersApi(
      undefined,
      `${process.env.REACT_APP_USER_API_URL_GATEWAY}`,
      axiosInstance
    );
  }
  else {
    return new ProvidersApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_USER_API_URL}`
    );
  }
}